<script lang="ts" setup>
import type { PropType} from 'vue';
import { onMounted, ref } from 'vue';
import type { ICellRendererParams } from 'ag-grid-community';
import BadgeIcon from '@/components/common/BadgeIcon.vue';
import type { SysarbColors } from '@/types';

type ExtendedParams = ICellRendererParams & {
    id: string;
    title: (params: ICellRendererParams) => string;
    icon: (params: ICellRendererParams) => string;
    filled: (params: ICellRendererParams) => boolean;
    primaryColor?: (params: ICellRendererParams) => SysarbColors;
    iconColor?: (params: ICellRendererParams) => SysarbColors;
    size?: (params: ICellRendererParams) => 'small' | 'medium' | 'large';
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = ref<string>('status');
const icon = ref<string>('check');
const filled = ref<boolean>(false);
const primaryColor = ref<SysarbColors>();
const iconColor = ref<SysarbColors>();
const size = ref<'small' | 'medium' | 'large'>();

onMounted(() => {
    title.value = typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title;
    icon.value = typeof props.params.icon === 'function' ? props.params.icon(props.params) : props.params.icon;
    filled.value = typeof props.params.filled === 'function' ? props.params.filled(props.params) : props.params.filled;
    primaryColor.value = typeof props.params.primaryColor === 'function' ? props.params.primaryColor(props.params) : props.params.primaryColor;
    iconColor.value = typeof props.params.iconColor === 'function' ? props.params.iconColor(props.params) : props.params.iconColor;
    size.value = typeof props.params.size === 'function'? props.params.size(props.params) : props.params.size;
});
</script>

<template>
    <div class="flex-container align-middle height-100 sy-spacer-x-3">
        <BadgeIcon
            :icon="icon"
            :filled="filled"
            :primary-color="primaryColor"
            :icon-color="iconColor"
            :size="size"
        />
        <span class="sy-truncate" :title="title">{{ title }}</span>
    </div>
</template>
